import React from 'react';
import Wrapper from '../components/Wrapper';
import { Typography } from 'antd';

const Home = () => {
  return (
    <Wrapper>
      <Typography.Text>Welcome to POS dashboard!</Typography.Text>
    </Wrapper>
  );
};

export default Home;
